import { LitElement, html, css } from '@hh/global.js'

class HHArticleGallery extends LitElement {
  static get properties() {
    return {
      imagesArray: { type: Array },
    }
  }

  constructor() {
    super()
    this.imagesArray = []
    this.mobileSizesArray = this.dataset.mobileSizes.split(',');
    this.desktopSizesArray = this.dataset.desktopSizes.split(',');
  }

  connectedCallback() {
    super.connectedCallback()
    this.updateComplete.then(() => {
      this._initGallery()
    })
  }

  _initGallery() {
    lightGallery(this.shadowRoot.querySelector('#lightgallery'), {
      selector: '.gallery-image',
      licenseKey: "8c0d8844-e85f-4081-8628-67a19224bbd7"
    })
  }

  render() {
    return html`
      <div id="lightgallery" class="gallery-images-container">
        ${this.imagesArray.map(
          (image, index) => html`
            <div class="gallery-image gallery-image--mobile-${this.mobileSizesArray[index]} gallery-image--desktop-${this.desktopSizesArray[index]}" data-src="${image}">
              <img src="${image}" />
            </div>
          `
        )}
      </div>
    `
  }

  static styles = css`
    .gallery-images-container {
      display: flex;
      flex-wrap: wrap;
      padding-top: 1rem;
      margin-left: -1rem;
    }
    @media screen and (min-width: 990px) {
      .gallery-images-container {
      	padding-top: 1.5rem;
      	margin-left: -1.5rem;
      }
    }
    .gallery-image--mobile-25 {
    	max-width: calc(25% - 1rem);
    	width: calc(25% - 1rem);
    }
    .gallery-image--mobile-33 {
    	max-width: calc(33.333% - 1rem);
    	width: calc(33.333% - 1rem);
    }
    .gallery-image--mobile-50 {
    	max-width: calc(50% - 1rem);
    	width: calc(50% - 1rem);
    }
    .gallery-image--mobile-100 {
    	max-width: 100%;
    	width: 100%;
    }
    @media screen and (min-width: 990px) {
	    .gallery-image--desktop-25 {
	    	max-width: calc(25% - 1.5rem);
	    	width: calc(25% - 1.5rem);
	    }
	    .gallery-image--desktop-33 {
	    	max-width: calc(33.333% - 1.5rem);
	    	width: calc(33.333% - 1.5rem);
	    }
	    .gallery-image--desktop-50 {
	    	max-width: calc(50% - 1.5rem);
	    	width: calc(50% - 1.5rem);
	    }
	    .gallery-image--desktop-100 {
	    	max-width: 100%;
	    	width: 100%;
	    }
    }
    .gallery-image {
      padding-left: 1rem;
      padding-bottom: 1rem;
    }
    .gallery-image img {
      display: block;
      width: 100%;
      max-width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
      cursor: pointer;
    }
    @media screen and (min-width: 990px) {
	    .gallery-image {
	      padding-left: 1.5rem;
	      padding-bottom: 1.5rem;
	    }
    }
  `
}

customElements.define('hh-article-gallery', HHArticleGallery)
